module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("73tvQ"))).then(() => parcelRequire('4DUyl'));